import React from 'react';
import { Card, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { themeConfig } from '../config/theme';

const { Title, Paragraph, Text } = Typography;

const TermsAndConditions = () => {
  return (
    <div style={{ padding: '50px', background: themeConfig.login.bgColor, minHeight: '100vh' }}>
      <Card>
        <div style={{ marginBottom: '20px' }}>
          <Link to="/login">
            <Button icon={<ArrowLeftOutlined />}>Back to Login</Button>
          </Link>
        </div>
        <Typography>
          <Title>Terms and Conditions</Title>

          <Paragraph>
            Welcome to Keshav Interiors HRMS. These terms and conditions govern your use of the Keshav Interiors HRMS mobile application and web dashboard ("the System"), operated by Keshav Interiors, located at 4th Floor, 405, Om Sai Sadan, N. M. Joshi Marg, Arthur Road Naka, Chinchpokli (W), Mumbai - 400011 (GST: 27CLCPS2523P1ZN).
          </Paragraph>

          <Paragraph>
            By accessing and using the System, you accept and agree to be bound by these terms and conditions. If you do not agree to these terms, you must not use the System.
          </Paragraph>

          <Title level={4}>1. System Access and Usage</Title>
          <Paragraph>
            <ul>
              <li>The System is for internal use only by employees, supervisors, and administrators of Keshav Interiors</li>
              <li>Access to the System is provided through mobile number authentication</li>
              <li>Each user can only access the System from their registered device</li>
              <li>You must not share your login credentials or allow others to access the System using your account</li>
              <li>You must not attempt to bypass any security measures implemented in the System</li>
            </ul>
          </Paragraph>

          <Title level={4}>2. User Roles and Responsibilities</Title>
          <Paragraph>
            <strong>Workers:</strong>
            <ul>
              <li>Can view their own attendance records</li>
              <li>Can access their personal salary slips</li>
              <li>Can view their advance payment logs</li>
              <li>Can request account deletion</li>
            </ul>
          </Paragraph>
          
          <Paragraph>
            <strong>Supervisors:</strong>
            <ul>
              <li>Have all worker privileges for their own records</li>
              <li>Can mark attendance for workers and other supervisors</li>
              <li>Can view attendance records of all users</li>
              <li>Can add and view advance payment logs for all users</li>
              <li>Must ensure accurate recording of attendance</li>
            </ul>
          </Paragraph>

          <Title level={4}>3. Data Accuracy and Integrity</Title>
          <Paragraph>
            <ul>
              <li>Users must ensure all information provided is accurate and truthful</li>
              <li>Supervisors must verify attendance records before submission</li>
              <li>Any discrepancies should be reported immediately to the admin</li>
              <li>Intentional misrepresentation of data may result in disciplinary action</li>
            </ul>
          </Paragraph>

          <Title level={4}>4. Device Registration</Title>
          <Paragraph>
            <ul>
              <li>Your account is linked to the first device you use to log in</li>
              <li>You cannot access your account from any other device</li>
              <li>Device reset requests must be made through the admin</li>
              <li>The company reserves the right to reset or revoke device access at any time</li>
            </ul>
          </Paragraph>

          <Title level={4}>5. Account Management</Title>
          <Paragraph>
            <ul>
              <li>Account creation is managed exclusively by system administrators</li>
              <li>Users can request account deletion through the mobile application</li>
              <li>Account deletion requests will be processed manually by administrators</li>
              <li>The company reserves the right to maintain certain records as required by law</li>
            </ul>
          </Paragraph>

          <Title level={4}>6. Prohibited Activities</Title>
          <Paragraph>
            Users must not:
            <ul>
              <li>Share access to their account with others</li>
              <li>Attempt to access data they are not authorized to view</li>
              <li>Use the System for any purpose other than intended business functions</li>
              <li>Modify, reverse engineer, or attempt to compromise the System</li>
              <li>Submit false or misleading information</li>
            </ul>
          </Paragraph>

          <Title level={4}>7. Termination</Title>
          <Paragraph>
            <ul>
              <li>Access to the System will be terminated upon employment cessation</li>
              <li>The company reserves the right to suspend or terminate access for policy violations</li>
              <li>Users may request account deletion as per the defined process</li>
            </ul>
          </Paragraph>

          <Title level={4}>8. Changes to Terms</Title>
          <Paragraph>
            We reserve the right to modify these terms at any time. Changes will be communicated through the System or through your supervisor.
          </Paragraph>

          <Title level={4}>9. Governing Law</Title>
          <Paragraph>
            These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Mumbai, Maharashtra.
          </Paragraph>

          <Paragraph>
            <Text strong>Last updated:</Text> 1 August 2024
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
};

export default TermsAndConditions; 